import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { resetButton } from '@/styles/common';
import { poppinsMediumFont } from '@/styles/typography';
import { flexCenter } from '@/styles/layout';

export const StepDot = styled.div<{ isActive: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${COLORS.grey[700]};

  ${({ isActive }) =>
    isActive &&
    `
      background-color: ${COLORS.white};
  `}
`;

export const OnboardingGuideButton = styled.button<{ variant?: 'back' | 'close' }>`
  ${flexCenter};
  ${resetButton};
  padding: 10px 16px;
  border-radius: 8px;
  background-color: ${COLORS.green[500]};
  ${poppinsMediumFont};
  font-size: 14px;
  color: ${COLORS.white};
  height: 34px;
  cursor: pointer;

  ${({ variant }) =>
    variant === 'back' &&
    `
      color: ${COLORS.green[350]};
      background-color: rgba(0, 178, 145, 0.08);
  `}

  ${({ variant }) =>
    variant === 'close' &&
    `
      color: ${COLORS.grey[650]};
      background-color: transparent;
  `}
`;
